module.exports = __webpack_public_path__ + "media/src/images/favicons/apple-touch-icon-76x76-cd554cf5f24bebe70785424452de3f45.png";